import CameraTracking from "./CameraTracking";

// Export without redux connection
export default CameraTracking;
